function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/* eslint semi: ["error", "never"]*/

/* eslint key-spacing: ["error", { "afterColon": true, "align": "value" }] */

/* eslint no-multi-spaces: ["error", { exceptions: { "ImportDeclaration": true,
                                       "VariableDeclarator": true  } }] */
import { getCustomAttributes, updateEntity } from '@engine/actions/creators/email/form';
import CheckboxField from '@engine/components/presentational/base/checkbox-field';
import { EmailConfiguration } from '@engine/lib/utility/email-variables';
import EmailConfigurationCustomAttributeFields from '@engine/components/containers/email-configurations/custom-attribute-fields';
import React from 'react';
import SelectField from '@engine/components/presentational/base/select-field';
import TagsField from '@engine/components/presentational/base/tags-field';
import TextField from '@engine/components/presentational/base/text-field';
import { connect } from 'react-redux';

var EmailConfigurationFormFields = /*#__PURE__*/function (_React$Component) {
  _inherits(EmailConfigurationFormFields, _React$Component);

  var _super = _createSuper(EmailConfigurationFormFields);

  function EmailConfigurationFormFields(props) {
    var _this;

    _classCallCheck(this, EmailConfigurationFormFields);

    _this = _super.call(this, props);
    _this.state = {
      configurationType: _this.getValueFor('configuration_type')
    };

    if (_this.state.configurationType) {
      _this.props.getCustomAttributes(_this.state.configurationType);
    }

    return _this;
  }

  _createClass(EmailConfigurationFormFields, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      return React.createElement("div", {
        id: "email-configuration-fields"
      }, this.props.isTypeEditable ? React.createElement(SelectField, {
        name: "configuration_type",
        value: this.getValueFor('configuration_type'),
        onChange: function onChange(value, name) {
          _this2.setState({
            configurationType: value
          });

          _this2.onChange(value, name);

          _this2.props.getCustomAttributes(value);
        },
        label: I18n.t('object.attributes.type'),
        options: this.props.emailConfigurationTypes
      }) : React.createElement(TextField, {
        name: "configuration_type",
        disabled: true,
        value: I18n.t('feature.emails.configuration_types.' + this.getValueFor('configuration_type')),
        label: I18n.t('object.attributes.type')
      }), React.createElement(TextField, {
        name: "name",
        value: this.getValueFor('name'),
        onChange: function onChange(value, name) {
          return _this2.onChange(value, name);
        },
        label: I18n.t('object.attributes.name')
      }), React.createElement(TagsField, {
        disabled: this.areRecipientsDisabled,
        name: "recipients",
        value: this.props.emailConfiguration && this.props.emailConfiguration.recipients.toString() || '',
        onChange: function onChange(value, name) {
          return _this2.onChange(value, name);
        },
        label: I18n.t('object.attributes.recipients')
      }), React.createElement(CheckboxField, {
        name: 'enabled',
        value: this.getValueFor('enabled'),
        onChange: function onChange(value, name) {
          return _this2.onChange(value, name);
        },
        label: "".concat(I18n.t('object.status.enabled'), "?")
      }), this.state.configurationType && React.createElement(EmailConfigurationCustomAttributeFields, {
        configurationType: this.state.configurationType,
        emailConfiguration: this.props.emailConfiguration,
        onChange: function onChange(value, name) {
          return _this2.onChange(value, name);
        }
      }));
    }
  }, {
    key: "areRecipientsDisabled",
    get: function get() {
      return EmailConfiguration.WITHOUT_RECIPIENTS.includes(this.state.configurationType);
    }
  }, {
    key: "getValueFor",
    value: function getValueFor(attribute) {
      return this.props.emailConfiguration && this.props.emailConfiguration[attribute];
    }
  }, {
    key: "onChange",
    value: function onChange(value, name) {
      this.props.updateEntity('configuration', _defineProperty({}, name, value));
    }
  }]);

  return EmailConfigurationFormFields;
}(React.Component);

export default connect(null, {
  getCustomAttributes: getCustomAttributes,
  updateEntity: updateEntity
})(EmailConfigurationFormFields);